import { useEffect } from 'react';

// eslint-disable-next-line no-restricted-imports
import { hasFeature } from 'components/shared/featureFlag';
import { useMediaQuery } from 'utils/mediaQuery';
import { useAppSelector } from 'utils/redux/useAppSelector';

import { useJabraDevices } from './utils/useJabraDevices/useJabraDevices';

/**
 * Checks feature flag, PWA and electron and initializes the jabra devices with
 * web usb
 */
export const useJabraInit = (): void => {
  const [isOpenedInPWA] = useMediaQuery('(display-mode: standalone)');
  const [initJabra, removeJabra] = useJabraDevices();
  const webUsbJabraFlag = hasFeature(
    useAppSelector((state) => state.settings.profile.featureflags),
    'web-usb-jabra-integration',
  );

  useEffect(() => {
    // Detect PWA and initialize or remove Jabra.
    if (isOpenedInPWA && webUsbJabraFlag) {
      initJabra();
    } else {
      removeJabra();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [webUsbJabraFlag, isOpenedInPWA]);
};
